import React, { Component } from 'react';
import { Log } from 'ng2-logger';
import Translator from '../../../core/i18n';
import { Common } from '../../../core/common';
import FileUpload  from '../../../components/file-upload/main';
import BaseModalStatic from '../../../modal/base-modal/main-static';
import { QuestionType } from '../../../models/enums/QuestionType';
import { IFileChoiceProps } from '../../../models/components/input-choice';
import { ActivityTypeEnums } from '../../../models/enums/ActivityType';
import { Notification } from '../../notification/main';

const T = Translator.create();
const _logger = Log.create('Input-File Choice');
let _common: Common;
export class FileChoice extends Component<IFileChoiceProps> {
    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    public render() {
        return (
            <React.Fragment>
                <div
                    className="answer_type_text"
                    id={'choices_' + this.props.index}
                    ref={this.props.provided.innerRef}
                    {...this.props.provided.draggableProps}
                >
                    <div
                        className={'control_group_answer w-75 survey_choose ' + (this.props.choice.isCorrect ? 'choosed-2' : '')}
                        style={{ float: 'left' }}
                    >
                        {this.props.formik.values.questionType === QuestionType.MultipleSingle && this.props.trueChoiseOnChange ? (
                            <label className="control control--radio">
                                <input
                                    type="checkbox"
                                    name={'trueChoise' + this.props.index}
                                    checked={this.props.choice.isCorrect}
                                    onChange={this.props.trueChoiseOnChange.bind(this, this.props.choice.displayOrder, this.props.formik)}
                                />
                                <div className="control__indicator" style={{ top: -4 }} />
                            </label>
                        ) : this.props.formik.values.questionType === QuestionType.MultipleMultiple && this.props.trueChoiseOnChange ? (
                            <label className="control control--checkbox">
                                <input
                                    type="checkbox"
                                    name={'trueChoise' + this.props.index}
                                    checked={this.props.choice.isCorrect}
                                    onChange={this.props.trueChoiseOnChange.bind(this, this.props.choice.displayOrder, this.props.formik)}
                                />
                                <div className="control__indicator" style={{ top: -4 }} />
                            </label>
                        ) : (
                            ''
                        )}

                        <span style={{ minWidth: 'max-content' }}>{this.props.choice.optionText})</span>
                        <a
                            className="attachment-btn attachment-btn-custom"
                            type="button"
                            aria-expanded="false"
                            style={{ background: 'white', cursor: 'default !important', paddingTop: 12 }}
                        >
                            <i className="material-icons mr-2">attach_file</i>
                            {T.t('r_question_add_photo_before_choice')}{' '}
                            <span
                                className="text-azure"
                                onClick={() => {
                                    if (this.props.formik.values.isExamQuestion) {
                                        Notification.setNotification(
                                            'error',
                                            T.t('r_api_gen_question_error_not_editable_exam_question'),
                                            'topRight'
                                        );
                                    }
                                    else {
                                        this.props.triggerModal(this.props.choice, this.props.formik, true)

                                    }
                                }
                                }
                                style={{ cursor: 'pointer' }}
                            >
                                {' '}
                                {T.t('r_question_add_photo_after_text')}
                            </span>
                        </a>
                    </div>
                    <div
                        className="w-20"
                        style={{
                            float: 'right',
                            boxShadow: '0 1px 2px rgb(0 0 0 / 10%)',
                            borderRadius: 8
                        }}
                    >
                        <div
                            className="btn_container center"
                            style={{
                                borderRadius: 8
                            }}
                        >
                            <span className="move_btn" {...this.props.provided.dragHandleProps} onClick={() => {
                                if (this.props.formik.values.isExamQuestion) {
                                    Notification.setNotification(
                                        'error',
                                        T.t('r_api_gen_question_error_not_editable_exam_question'),
                                        'topRight'
                                    );
                                }
                            }}>
                                <i className="material-icons">open_with</i>
                            </span>
                            <span className="delete_btn" onClick={() => {
                                if (this.props.formik.values.isExamQuestion) {
                                    Notification.setNotification(
                                        'error',
                                        T.t('r_api_gen_question_error_not_editable_exam_question'),
                                        'topRight'
                                    );
                                }
                                else {
                                    this.props.deleteChoice(this.props.choice)

                                }
                            }}>
                                <i className="material-icons">close</i>
                            </span>
                        </div>
                    </div>

                    {this.props.choice.isPreviewFile ? (
                        <div
                            className="col-12 uploaded_file_container mt-4"
                            style={{ display: 'flex', height: 300, justifyContent: 'center' }}
                        >
                            <div className="uploaded_file">
                                <img src={this.props.choice.file} style={{ width: '100%', height: '100%' }} />
                                <a
                                    onClick={() => {
                                        if (this.props.formik.values.isExamQuestion) {
                                            Notification.setNotification(
                                                'error',
                                                T.t('r_api_gen_question_error_not_editable_exam_question'),
                                                'topRight'
                                            );
                                            return;
                                        }
                                        this.props.handleDeleteFileConfirm(this.props.choice, this.props.formik)
                                    }}
                                    className="file_delete_btn"
                                >
                                    <i className="material-icons">close</i>
                                </a>
                            </div>
                        </div>
                    ) : (
                        ''
                    )}

                    <BaseModalStatic
                        minWidth={650}
                        modalIsOpen={this.props.choice.isModalOpen}
                        onClose={this.props.triggerModal.bind(this, this.props.choice, this.props.formik, false)}
                        headerState={T.t('r_report_template_modal_header')}
                        headerIcon={'clock'}
                        modalBodyClassName={'modal-body pt-2 file-upload-modal-body'}
                        modalHeaderClassName={'modal-header border-0 d-flex justify-content-between p-0 file-upload-modal-header'}
                        modalContentClassName={'modal-content file-upload-modal-content'}
                    >
                        <FileUpload
                            key={this.props.choice.fileInputKey}
                            fileInputKey={this.props.choice.fileInputKey}
                            height={400}
                            maxFileSize={2000000000}
                            maxSelectedFileCount={1}
                            isCardImage={false}
                            formik={this.props.formik}
                            fileTypes={".png,.jpg,.jpeg"}
                            afterFileUploadChoice={this.props.afterFileUploadChoice}
                            afterFileDeleteChoice={this.props.afterFileDeleteChoice}
                            willDeleteFile={this.props.choice.willDeleteFile}
                            choice={this.props.choice}
                        />
                    </BaseModalStatic>
                </div>
            </React.Fragment>
        );
    }
}
